// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ImgResponsive":"bci_a bib_a bib_q bib_j bib_wl bib_bj","ImgResponsive__img":"bci_b bib_b bib_ql"};